import { AudioCapture } from './AudioCapture';
import { SkylarAPI } from './SkylarAPI';
import { AudioPlayer } from './Audio';
import AgentVisualizer from './Control/AgentVisualizer';
import SpeakerVisualizer from './Control/SpeakerVisualizer';


class InterviewClient {
	app;
	audioPlayer;

	// Max time for "short listen" in milliseconds.
	shortListenMS = 750;

	constructor( config, app ) {
		this.config = config;
		if ( app ) {
			this.app = app;
		}

		this.api = new SkylarAPI();
		this.starting_interview = true;
		this.agentResponding = false;
		this.interrupting = false;

	}

	async init( app ) {
		const config = this.config;
		this.audioPlayer = app.audioPlayer;
		this.audioCapture = new AudioCapture( config );
		await this.audioCapture.init( app.mic );

		if ( config.interview ) {
			this.setupElements();
			this.setupAudioEvents();
			this.subject = config.interview;
			this.setupTriggers();

		}

		if ( this.config.start ) {
			this.sendMessage( config.start );
		}
	}

	setupElements() {
		this.outputElement = document.querySelector( '#agent_output' );
		this.visualizer = new AgentVisualizer( document.querySelector( '#audio_anim' ), document.body, this.app );
		this.volumeMeter = new SpeakerVisualizer( document.querySelector( '#speaker_visualizer' ) );
		this.trigger = document.querySelector( '#talk_trigger' ) || document;
		this.visualizer.setSource( this.audioPlayer.audio );
	}

	hotkeyListener( down, up, keycode ) {
		keycode = keycode || 'Space';
		if ( down ) {
			document.addEventListener( 'keydown', e => {
				if ( e.code == keycode ) {
					e.preventDefault();
					if ( e.repeat ) { return; }
					down(e);
				}
			});
		}

		if ( up ) {
			document.addEventListener( 'keyup', e => {
				if ( e.code == keycode ) {
					e.preventDefault();
					up(e);
				}
			});
		}
	}

	touchListener( down, up, target ) {
		target = target || document;

		const ctxmenu = e => {
			e.preventDefault();
		};

		if ( down ) {
			target.addEventListener( 'touchstart', e => {
				e.preventDefault();
				target.addEventListener( 'contextmenu', ctxmenu );
				down(e);
			});
		}

		if ( up ) {
			target.addEventListener( 'touchend', e => {
				e.preventDefault();
				up(e);
				target.removeEventListener( 'contextmenu', ctxmenu );
			});
		}

	}

	setupTriggers() {
		this.hotkeyListener(
			() => this.startListening(),
			() => this.stopListening()
		);

		this.touchListener(
			() => { this.setListening( true ); this.startListening(); },
			() => { this.setListening( false ); this.stopListening(); },
			this.trigger
		);
	}


	async startListening(e) {
		if ( this.agentResponding ) {
			this.interruptResponse();

			this.agentResponding = false;
		}

		try {
			this.listents = Date.now();
			this.updateStatus('Listening...');
			await this.audioCapture.start();

			this.volumeMeter.setSource( this.audioCapture.stream );
			this.volumeMeter.setSpeaking( true );

		} catch (error) {
			this.updateStatus('Error starting audio capture');
			console.error(error);
			this.volumeMeter.setSpeaking( false );
		}
	}

	async stopListening(e) {
		try {
			const shortListen = ( Date.now() - this.listents ) < this.shortListenMS;
			shortListen && console.log( 'Short listen...' );
			const cb = shortListen ? null : async (audioBlob) => {
				await this.recognizeAudio( audioBlob );
			};

			this.audioCapture.stop( cb );
			this.volumeMeter.setSpeaking( false );

			if ( !shortListen ) {
				this.updateStatus('Processing...');
			}
		} catch (error) {
			this.updateStatus('Error processing audio');
			console.error(error);

		}
	}

	setListening( is_listening ) {
		if ( document.body ) {
			document.body.classList.toggle( 'listening', is_listening );
		}
	}

	async recognizeAudio( audioBlob ) {
		this.agentResponding = true;

		this.updateStatus( 'Sending audio' );
		this.visualizer.setThinking( true );

		let responseAudio;

		try {
			responseAudio = await this.api.conversation( audioBlob );
			await this.handleResponse( responseAudio );


		} catch( error ) {
			this.updateStatus( 'Error recognizing audio' );
			console.error( error );
			this.visualizer.setThinking( false );
		}
	}

	async sendMessage( message, interrupting ) {
		this.agentResponding = true;
		const response = await this.sendTextToAgent(message, this.starting_interview ? this.subject : false, interrupting );
		let endAction = null;
		let text = response.text;

		if ( this.starting_interview ) {
			this.starting_interview = false;
		}

		await this.handleResponse( response );
	}

	async handleResponse( response ) {
		let endAction = null;

		if ( response.text ) {
			let { text } = response;
			if ( text.indexOf( '<wrap_up>' ) !== -1 ) {
				console.log( 'Wrapping up.' );
				text = text.replace( '<wrap_up>', '' );

				endAction = () => {
					console.log( 'Setting wrapup timer' );
					const nextPage = () => { location.href = '/promo'; 	};
					// Go to next page after 10 seconds or when TALK is pressed.
					setTimeout( nextPage, 7000 );
					// @todo: Hotkey listener
					//this.app.hotkeyListener( nextPage );
				};
			}
		}

		// Handle special control messages here.
		if ( response.redirect ) {

			if ( response.redirect_delay ) {
				setTimeout( () => { location.href = response.redirect }, response.redirect_delay );
			} else {
				location.href = response.redirect;
				return;
			}
		}

		if ( response.audio_base64 ) {
			//const audioData = Base64.parse( response.audio_base64 );
			//response.audioData = new Blob( [audioData], { type: 'audio/mpeg' });
			//delete ressponse.audio_base64;
		}

		this.playAudio( response, endAction );
	}

	async sendTextToAgent( message, reset_subject, interrupting ) {
		return this.api.conversation( message, reset_subject, interrupting );
	}

	async playAudio( data, afterDone ) {
		this.afterDone = afterDone || null;
		this.messagedata = data.messagedata || null;
		this.visualizer.setSpeaking( true );

		try {
			await this.audioPlayer.playFromBase64( data.audio_base64 );
		} catch(e) {
			console.error(e);
		}
	}


	setupAudioEvents() {
		const audio = this.audioPlayer.audio;

		audio.addEventListener( 'ended', () => {
			this.visualizer.setSpeaking( false );
			this.agentResponding = false;
			this.interrupting = false;

			if ( this.afterDone ) {
				this.afterDone();
			}
		});

		// Buffering
		audio.addEventListener( 'waiting', () => {
			this.visualizer.setThinking( true );
		});

		// Playback resumes.
		audio.addEventListener( 'playing', (e) => {
			this.visualizer.setThinking( false );
		});

		audio.addEventListener( 'timeupdate', () => {
			if ( !this.outputElement ) {
				return;
			}

			if ( !this.messagedata ) {
				return;
			}

			const time = audio.currentTime;
			let text = '';

			const { segment, start } = this.messagedata;

			for( let i=0,n=segment.length; i<n; i++ ) {
				if ( time < start[i] ) {
					break;
				}

				text += segment[i];
			}

			const el = this.outputElement;
			el.textContent = text;
			el.scrollTop = el.scrollHeight;

		});

	}


	interruptResponse() {
		console.log( 'Interrupting response!' );
		this.interrupting = true;
		this.visualizer.setSpeaking( false );
		this.visualizer.setThinking( false );
		this.api.cancelRequest();
		this.audioPlayer && this.audioPlayer.pause();

		// Needed to wait until player events are completed.
		setTimeout( () => this.displayText(''), 0 );
	}

	updateStatus( message ) {
		console.log( 'Status:', message );
	}

	displayText( message ) {
		if ( this.outputElement ) {
			console.log( 'text', message );
			this.outputElement.textContent = message;
		}
	}

}

export default InterviewClient;
